import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, GROUPS, RPYM_AMT } from './state';

const selectDate = (state, { from, to }) => {
	state.searchParams.startDcsnDd = from;
	state.searchParams.endDcsnDd = to;
};

export default {
	...common,
	selectDate,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.rpymAmt = RPYM_AMT();
		state.groups = GROUPS();
		state.gridList = [];
		state.repayMst = [];
		state.ctypeList = [];
		state.clmDd02List = [];
		state.excelDownLoadList = [];
	},
	[types.STATE_CLEAR]: state => {
		state.rpymAmt = RPYM_AMT();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.GROUPS]: (state, { key, value }) => {
		state.groups[key] = value;
	},
	[types.RPYM_AMT]: (state, { key, value }) => {
		state.rpymAmt[key] = value;
	}
};
